module.exports = __webpack_public_path__ + "images/花筑奢pr长图_04-2.jpg?v=6c996866";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu2/花筑奢pr长图_04-2.jpg
 ** module id = 31
 ** module chunks = 1 2
 **/